<template>
  <div
    class="init-clock animate__animated"
    id="init-content"
    :class="{ animate__slideOutUp: backAnimate }"
    v-pageBuried
    data-page-buried="BG_YINDAOYE"
  >
    <AppNavBar title="" :placeholder="true" :options="options" :z-index="1000">
    </AppNavBar>
    <div class="content">
      <div class="step-scroll">
        <div class="step-content">
          <img
            class="image-1 fadeIn"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/212a5dd44dd16c629aef9b96a9cb1feb.png"
            alt=""
          />
          <img
            class="image-2 fadeInUp"
            :style="{ animationDelay: '0.3s' }"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8cfac5d17a23eaa441847ea87e57373a.png"
            alt=""
          />
          <img
            class="image-3 fadeInUp"
            :style="{ animationDelay: '0.4s' }"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1046124359584d76dbe31dbdaa6afe90.png"
            alt=""
          />
          <img
            class="image-4 fadeInUp"
            :style="{ animationDelay: '0.5s' }"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/12db9b1b40c74ecbe7227331169070ca.png"
            alt=""
          />
          <div class="image-content image-content-1">
            <img
              class="image-5 fadeInUp"
              :style="{ animationDelay: '1s' }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c7ed684ea6eca71e2a04283f724bffaf.png"
              alt=""
            />
            <img
              class="image-6 animate__animated animate__fadeInRight"
              :style="{ animationDelay: '1.2s' }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fa933ae8840c6a900231643c7502cef5.png"
              alt=""
            />
            <img
              class="image-7 animate__animated animate__fadeInRight"
              :style="{ animationDelay: '1.3s' }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a35ec1bdcbe02bf53d5b76eb2e0fc6ae.png"
              alt=""
            />
            <img
              class="image-8 fadeInScale"
              :style="{ animationDelay: '2s' }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a68d274f05da2c1cb599ec56f082d56.png"
              alt=""
            />
          </div>
          <img
            class="image-9 fadeInUp"
            :style="{ animationDelay: '0.6s' }"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/81cae6707cc64a55d618b317557368ac.png"
            alt=""
          />
          <div class="image-content">
            <img
              class="image-10 fadeInUp"
              :style="{ animationDelay: '0.7s' }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee182caad7889ead01f885c52803621a.png"
              alt=""
            />
            <img
              class="image-11 fadeInScale"
              :style="{ animationDelay: '2.3s' }"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2a68d274f05da2c1cb599ec56f082d56.png"
              alt=""
            />
          </div>
          <div
            class="start-btn fadeInUp"
            :style="{ animationDelay: '2.4s' }"
            @click="bindEnd"
            v-buried
            data-buried="BG_BUTTON_SHIYONG"
            v-clickBuried
            data-click-buried="CLICK_BUTTON_SHIYONG"
            >开始使用</div
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
export default {
  components: { AppNavBar },
  data() {
    return {
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)'
      },
      curStep: 1,
      backAnimate: false,
      showNext: false,
      animateData: [
        {
          images: []
        },
        {}
      ]
    }
  },
  created() {},
  mounted() {
    this.addEventAnimate()
  },
  methods: {
    bindEnd() {
      this.backAnimate = true
      setTimeout(() => {
        this.$emit('end')
      }, 1000)
    },
    bindTouchStart(e) {
      this.startY = e.touches[0].pageY
      let target = this.$refs.scroll
      let scrollHeight = target.scrollHeight
      let scrollTop = target.scrollTop
      let offsetHeight = target.offsetHeight
      let isBottom = scrollHeight - offsetHeight - scrollTop <= 2 ? true : false
      this.canNext = isBottom
    },
    bindTouchEnd(e) {
      if (!this.canNext) {
        return
      }
      let target = this.$refs.scroll
      let scrollHeight = target.scrollHeight
      let scrollTop = target.scrollTop
      let offsetHeight = target.offsetHeight
      let isBottom = scrollHeight - offsetHeight - scrollTop <= 2 ? true : false
      let endY = e.changedTouches[0].pageY
      let position = endY - this.startY
      if (position < -100) {
        if (isBottom && this.curStep < 2) {
          this.curStep = this.curStep + 1
        }
      }
    },
    addEventAnimate() {
      document
        .getElementById('step1-end-image')
        ?.addEventListener('animationend', (event) => {
          this.showNext = true
        })
    },
    addEventAnimateEnd() {
      document
        .getElementById('step2-end-image')
        ?.addEventListener('animationend', (event) => {
          console.log('动画结束')
          let content = document.getElementById('init-content')
          content.scrollTo(0, content.scrollHeight)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.init-clock {
  width: 100vw;
  height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b4affb7f969b6ddd48860c52d3dd7673.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  animation-duration: 0.5s;

  .content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    box-sizing: border-box;

    .step-scroll {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      .step-content {
        overflow: hidden;

        .image-content {
          position: relative;
        }

        .image-content-1 {
          margin-bottom: 23px;
        }

        img {
          width: 100%;
        }

        .image-1 {
          height: 63px;
          margin-bottom: 30px;
        }

        .image-2 {
          height: 56px;
          margin-bottom: 27px;
        }

        .image-3 {
          height: 14px;
          margin-bottom: 8px;
        }

        .image-4 {
          height: 50px;
        }

        .image-5 {
          z-index: 1;
          position: absolute;
          left: 20px;
          top: -6px;
          width: 154px;
          height: 139px;
        }

        .image-6 {
          height: 47px;
        }

        .image-7 {
          height: 80px;
        }

        .image-8 {
          position: absolute;
          right: 20px;
          bottom: 6px;
          width: 74px;
          height: 74px;
        }

        .image-9 {
          height: 18px;
          margin-bottom: 4px;
        }

        .image-10 {
          height: 177px;
        }

        .image-11 {
          position: absolute;
          right: 20px;
          top: -6px;
          width: 74px;
          height: 74px;
        }
      }
    }
  }

  .tips {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    padding: 10px 0px;
    @include paddingBottom(10px);
    animation-iteration-count: infinite;
    animation-duration: 2.5s;
  }

  img {
    object-fit: contain;
    width: 100%;
  }

  .title-image {
    margin-top: 10px;
    height: 62px;
    margin-bottom: 30px;
  }

  .start-btn {
    width: 252px;
    height: 48px;
    background: #00cddf;
    border-radius: 24px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    margin: 14px auto 16px;
  }
}
.fadeInUp {
  animation: fadeUp 1s ease;
  animation-fill-mode: both;
}
.fadeIn {
  animation: fade 1.5s ease;
  animation-fill-mode: both;
}
.fadeInScale {
  animation: fadeScale 0.2s ease-in;
  animation-fill-mode: both;
}
@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 6px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeScale {
  0% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
